module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAAFCAQAAAAnZu5uAAAAF0lEQVQI12NgAIEGIIQzGhAMTHEIhwEAwzcHAYthdVUAAAAASUVORK5CYII="